import WrapperService from "@/modules/core/services/wrapper-service";
import {createPageableParams} from "@/modules/core/services/table-utils";

const serviceName = 'Invoice-Documentation-Service: ';
const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/task/invoice-documentation';
const sortTableFields = ["name"];
const sortDatabaseFields = ["name"];
export default class InvoiceDocumentationService {


  static async saveOrUpdate(documentationDto, file, succsessF, errorF) {
    let isEdit = documentationDto.id ? true:false;

    let formData = new FormData();
    if (file && file.name) {
      formData.append("document", file, file.name);
    }

    formData.append("documentationDto", JSON.stringify(documentationDto));

    if (isEdit) {
      await WrapperService.put(API_URL + '/update/' + documentationDto.id, formData, serviceName, succsessF, errorF);
    } else {
      await WrapperService.post(API_URL + '/create', formData, serviceName, succsessF, errorF);
    }
  }

  static async readAllDocuments(taskId, succesF, errorF) {
    await WrapperService.get(API_URL + '/all-by-task/' + taskId, null, serviceName, succesF, errorF);
  }

  static async readAllPaginatedByTaskIdFromAPI(taskId, page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortTableFields, sortDatabaseFields);
    await WrapperService.get(API_URL + '/task/' + taskId, {params: params}, serviceName, successF, errorF);
  }

  static async removeInvoice(invoice, succesF, errorF){
    await WrapperService.delete(API_URL + '/' + invoice.id, serviceName, succesF, errorF);
  }

}